import { render, staticRenderFns } from "./VendorTransactions.vue?vue&type=template&id=8f81e512"
import script from "./VendorTransactions.vue?vue&type=script&lang=js"
export * from "./VendorTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports